export default __webpack_public_path__ + "static/media/go-and-tell.174389d7.svg";